import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { MUTATION_TYPE, useToast } from "hooks";
import { DUPLICATE_INTERVIEW } from "graphql/mutations";
import { SIZE, TYPE } from "components/Form";
import { ModalForm } from "components/Modal";

/**
 * RoleInterviewSaveAsTemplateModal
 *
 * @param {Object}    missionRole
 * @param {Object}    interview
 * @param {Boolean}   show
 * @param {Function}  onClose
 */
const RoleInterviewSaveAsTemplateModal = ({ missionRole, interview, show, onClose, ...props }) => {
  const { toast } = useToast();

  const handleCompleted = () => {
    toast.success(<FormattedMessage id="Missions.Roles.RoleInterviewSaveAsTemplateModal.SaveSuccess" />);
  };

  const handleError = () => {
    toast.error(<FormattedMessage id="Missions.Roles.RoleInterviewSaveAsTemplateModal.SaveError" />);
  };

  return (
    <ModalForm
      show={show}
      title={<FormattedMessage id="Missions.Roles.RoleInterviewSaveAsTemplateModal.Title" />}
      onClose={onClose}
      data={FORM_DATA}
      onCompleted={handleCompleted}
      onError={handleError}
      parentKeyName="interviewId"
      parentKeyValue={interview?.id}
      mutationType={MUTATION_TYPE.add}
      mutationData={{
        mutationName: {
          add: DUPLICATE_INTERVIEW,
        },
      }}
      initialValues={{
        newName: missionRole?.name,
        asTemplate: true,
      }}
      {...props}
    />
  );
};

const FORM_DATA = [
  {
    items: [
      {
        label: "Template Name",
        type: TYPE.input,
        size: SIZE.xlarge,
        properties: {
          name: "newName",
          placeholder: "Enter template name",
          required: true,
        },
      },
      {
        type: TYPE.hidden,
        properties: {
          name: "asTemplate",
        },
      },
    ],
  },
];

RoleInterviewSaveAsTemplateModal.propTypes = {
  missionRole: PropTypes.object.isRequired,
  interview: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RoleInterviewSaveAsTemplateModal;
